import React, { Component }      from "react";
import { FontAwesomeIcon }       from '@fortawesome/react-fontawesome'
import { Button, Modal }         from "react-bootstrap";
import LoaderButton              from "../../components/LoaderButton";
import { invokeGetAthleteNotes,
         invokeSetAthleteNotes } from "../../utils/AwsInvoke";
import { WhiteLabel }            from "../../utils/WhiteLabelProps";
import "../../css/modal/ModalExerciseNotes.css";

var white_label      = WhiteLabel();
const MainColor      = white_label.company_primary_btn_color;
const CloseBtnColor  = white_label.company_close_btn_color;

export default class ModalExerciseAthleteNotes extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalSimple: false
        };

        this.handleTextChange = this.handleTextChange.bind(this);
    }

    async componentDidMount() {
        this.renderShowNotes();
    }

    async renderShowNotes() {
        var exercise_id = this.props.exercise_id;

        var results     = await invokeGetAthleteNotes(exercise_id);
        if(results.status) {
            this.setState({
                notes: results.notes
            })
        }
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13) {
             this.props.onHide();
        }
    }

    createMarkup(text) { return {__html: text}; };

    handleTextChange(event) {
        this.setState({notes: event.target.value});
    }

    handleSubmit = async event => {
        var notes       = this.state.notes;
        var exercise_id = this.props.exercise_id;

          if(notes === "") {
              alert("Please add text to your note.")
              return;
          }

          const results = await invokeSetAthleteNotes(exercise_id, notes);
          console.log("results.status: " + results.status);
          if(results.status) {
              // Close Modal //
              this.props.onHide();
          } else
              this.setState({
                  error_msg: "Ooops, looks like there was an error. Try again."
              })
      }

    render() {
        var notes = this.props.notes;

        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                style={{position:"relative", top:40}}
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26p" style={{fontSize: 22}}>
                        <FontAwesomeIcon icon="sticky-note" />&nbsp; Athlete Notes
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <span style={{fontSize:20}}>
                      <b>{ this.props.exercise_name }</b>
                  </span>
                  <br/><br/>

                  <div className="modalFormLabelBody">
                       <div dangerouslySetInnerHTML={this.createMarkup(this.props.notes)} />

                        <textarea value={this.state.notes}
                                  onChange={this.handleTextChange}
                                  style={{height: 220, width: "100%", fontSize:20}}/>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                      <LoaderButton
                          height   = "38px"
                          width    = "100px"
                          fontSize = "17px"
                          type     = "submit"
                          btncolor = { CloseBtnColor }
                          isLoading= {this.state.isLoading}
                          text     = "Close"
                          onClick     = {this.props.onHide}
                          loadingText = "Closing …"
                        />
                      &nbsp; &nbsp;
                      <LoaderButton
                          height   = "38px"
                          width    = "120px"
                          fontSize = "17px"
                          type     = "submit"
                          btncolor = { MainColor }
                          isLoading= {this.state.isLoading}
                          text     = "SAVE"
                          onClick     = {this.handleSubmit}
                          loadingText ="Saving Notes …"
                        />
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalExerciseAthleteNotes.js